export default function AchievementToast({ achievement, onDismiss }) {
    if (!achievement) return null;

    return (
        <div
            onClick={onDismiss}
            style={{
                position: 'fixed',
                bottom: '24px',
                right: '24px',
                backgroundColor: '#1a1a2e',
                color: 'white',
                borderRadius: '12px',
                padding: '16px 20px',
                display: 'flex',
                alignItems: 'center',
                gap: '14px',
                boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
                cursor: 'pointer',
                zIndex: 2000,
                maxWidth: '340px',
                animation: 'slideIn 0.3s ease-out',
            }}
        >
            <div style={{ fontSize: '32px', flexShrink: 0 }}>{achievement.icon}</div>
            <div>
                <div style={{ fontSize: '11px', fontWeight: '700', color: '#a5b4fc', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                    Haut fait débloqué
                </div>
                <div style={{ fontSize: '15px', fontWeight: '700', marginTop: '2px' }}>
                    {achievement.title}
                </div>
                <div style={{ fontSize: '12px', color: '#c7c7d9', marginTop: '2px' }}>
                    {achievement.description}
                </div>
            </div>
            <style>{`
                @keyframes slideIn {
                    from { transform: translateX(100%); opacity: 0; }
                    to { transform: translateX(0); opacity: 1; }
                }
            `}</style>
        </div>
    );
}